import { render, staticRenderFns } from "./logisticsRevise.vue?vue&type=template&id=68a5003f&scoped=true"
import script from "./logisticsRevise.vue?vue&type=script&lang=js"
export * from "./logisticsRevise.vue?vue&type=script&lang=js"
import style0 from "./logisticsRevise.vue?vue&type=style&index=0&id=68a5003f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5003f",
  null
  
)

export default component.exports